import { render } from "./FooterServicesIntro.vue?vue&type=template&id=16e89006&scoped=true"
import script from "./FooterServicesIntro.vue?vue&type=script&lang=js"
export * from "./FooterServicesIntro.vue?vue&type=script&lang=js"

import "./FooterServicesIntro.vue?vue&type=style&index=0&id=16e89006&scoped=true&lang=css"

import exportComponent from "E:\\AStrick-Web\\vue-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e89006"]])

export default __exports__